import React, { Component } from 'react';

export class AcceptLink extends Component {

    constructor(props) {
        super(props);
        this.state = { acceptStatus: this.props.accepted ? 'Accepted' : '' };
        this.acceptQuoteItem = this.acceptQuoteItem.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({acceptStatus: 'Clicked'});
        this.acceptQuoteItem()
    }

    acceptQuoteItem() {
        fetch(this.props.acceptUrl, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.props.acceptCode)
        })
            .then(response => {
                if (response.ok) {
                    this.setState({ acceptStatus: 'Accepted' });
                    this.props.onAccept(this.props.acceptCode);
                } else {
                    this.setState({ acceptStatus: 'AcceptError' });
                    throw new Error("failed to accept quote item");
                }
            })
            .catch(err => {
                this.setState({ acceptStatus: 'AcceptError' });
                console.error(err.message);
            });
    }

    render() {
        let acceptMarkup = <button className="btn btn-primary hidden-print" onClick={this.handleClick}>Click to Accept</button>;

        switch (this.state.acceptStatus) {
            case 'Clicked':
                acceptMarkup = <button className="btn btn-default disabled hidden-print">Please wait...</button>;
                break;
            case 'Accepted':
                acceptMarkup = <button className="btn btn-success disabled hidden-print">Accepted</button>;
                break;
            case 'AcceptError':
                acceptMarkup = <button className="btn btn-danger disabled hidden-print">Error</button>;
                break;
            default:
                break;
        }

        return (
            acceptMarkup
        );
    }
}